export const GET_VOUCHER_REQUESTS_LIST_REQUEST =
  "GET_VOUCHER_REQUESTS_LIST_REQUEST";
export const GET_VOUCHER_REQUESTS_LIST_RESPONSE =
  "GET_VOUCHER_REQUESTS_LIST_RESPONSE";
export const GET_VOUCHERS_USED_NOT_USED_LIST_REQUEST =
  "GET_VOUCHERS_USED_NOT_USED_LIST_REQUEST";
export const GET_VOUCHERS_USED_NOT_USED_LIST_RESPONSE =
  "GET_VOUCHERS_USED_NOT_USED_LIST_RESPONSE";
export const GENERATE_VOUCHER_REQUEST = "GENERATE_VOUCHER_REQUEST";
